export const iconFontAwesomeSportsFitnessPersonHiking = (
	<i className="fa-solid fa-person-hiking"></i>
);
